// BG
(() => {
  const table = document.querySelector(".sunday-insider__table");
  const slideshow = document.querySelector(".homepage-slideshow");

  if (!table || !slideshow) {
    return;
  }

  const tableSection = table.closest("section");
  const tableShopifySection = tableSection.closest(".shopify-section");

  let titleSection =
    tableShopifySection.previousElementSibling?.querySelector(
      'section[data-section-type="rich-text"]'
    ) || null;
  let buttonSection =
    tableShopifySection.nextElementSibling?.querySelector(
      'section[data-section-type="rich-text"]'
    ) || null;

  tableShopifySection.classList.add("sunday-insider__table-wrapper");
  tableShopifySection.insertBefore(titleSection, tableSection);
  tableShopifySection.appendChild(slideshow);
  tableShopifySection.appendChild(buttonSection);
})();
